import getValue from "object-getvalue"
import domUtil from "lib/dom/dom-util"
import { getDY_SR } from "stackerConfig"

// Utility functions out of alpha-order
// due to dependencies further below

function isInViewport(elem) {
  const bounding = elem.getBoundingClientRect()
  const header = document.querySelector(".header-desktop")
  const headerHeight = header.getBoundingClientRect().height
  return (
    bounding.bottom - headerHeight > 0 &&
    bounding.right > 0 &&
    bounding.left <
      (window.innerWidth || document.documentElement.clientWidth) &&
    bounding.top < (window.innerHeight || document.documentElement.clientHeight)
  )
}

function handleScrollAnimations() {
  const allComponentsToBeAnimated = Array.from(
    document.querySelectorAll(".animate-component")
  )
  const allVideos = Array.from(
    document.querySelectorAll(".side-nav-promo video")
  )
  const windowHeight = window.innerHeight
  allComponentsToBeAnimated.forEach((component) => {
    const boundaries = component.getBoundingClientRect().top
    if (
      boundaries < windowHeight - 100 &&
      !domUtil.hasClass(component, "animate-fadeIn")
    ) {
      component.classList.remove("animate-fadeOut")
      component.classList.add("animate-fadeIn")
    }
    if (
      boundaries > windowHeight &&
      domUtil.hasClass(component, "animate-fadeIn")
    ) {
      component.classList.add("animate-fadeOut")
      component.classList.remove("animate-fadeIn")
    }
  })

  if (allVideos.length > 0) {
    allVideos.forEach((video) => {
      const { autoplay } = video.dataset
      const classList = Array.from(video.classList)
      const autoplayEnabled = autoplay === "true"
      if (isInViewport(video)) {
        if (autoplayEnabled && classList.indexOf("video-interacted") === -1) {
          video.play()
        }
      } else if (!isInViewport(video)) {
        if (classList.indexOf("video-interacted") === -1) {
          video.currentTime = 0
          video.pause()
        } else if (!video.paused) {
          video.pause()
        }
      } else {
        // console log exception case to be handled
      }

      video.onpause = () => {
        if (isInViewport(video) && video.currentTime > 0) {
          video.classList.add("video-interacted")
        }
      }
    })
  }
}

// Remaining utilities in alpha-order

function animateComponents() {
  window.addEventListener("scroll", handleScrollAnimations)
}

function convertToSlug(Text) {
  return Text.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "")
}

function formatPreorderDate(inputDate) {
  const i = inputDate.split("/")
  const date = new Date(i[2], i[1] - 1, i[0])

  const formattedDate = [
    date.getMonth() + 1,
    date.getDate(),
    date.getFullYear(),
  ].join("/")

  return formattedDate
}

const filterVariant = (options) => {
  const { variantOptions, selectedVariantCode, retailerProducts } = options
  const fixedVarCode = selectedVariantCode.split("-").join(" ")
  let selectedVariantIndex = 0
  let selectedVariant = {}
  ;[selectedVariant] = variantOptions.filter((variant, index) => {
    if (variant.code === fixedVarCode) {
      selectedVariantIndex = index
    }
    return variant.code === selectedVariantCode
  })

  selectedVariant.variantOptions = selectedVariant.variantOptions.filter(
    (opt) => retailerProducts.some((_) => _.dySku === opt.code)
  )

  selectedVariant.variantOptions = selectedVariant.variantOptions.map((opt) => {
    var retailerProduct = retailerProducts.find((_) => _.dySku === opt.code)
    return {
      ...opt,
      price: {
        ...opt.price,
        value: retailerProduct.price,
        formattedValue: retailerProduct.price.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        }),
      },
    }
  })

  return {
    selectedVariant,
    selectedVariantIndex,
  }
}

const getCategoryForMensPLP = (allCategories, category) => {
  const cat = allCategories.filter(({ code }) => {
    if (code === category) {
      return true
    }
    return false
  })
  return cat && cat.length > 0 && cat[0].values
}

function getGridItems(products, filters) {
  const newList = products.products.slice()
  const contentModules = getDY_SR().data.mensBrandsGridItems

  if (contentModules) {
    let contentModulePosition = 7
    contentModules.forEach((item, index) => {
      if (
        item.displayList &&
        (item.displayList.includes("always") ||
          (filters.length === 0 && item.displayList.includes("none")) ||
          (filters.length > 0 &&
            item.displayList.some((displayListItem) => {
              return filters.includes(convertToSlug(displayListItem))
            })))
      ) {
        if (contentModulePosition < newList.length) {
          newList.splice(contentModulePosition, 0, {
            ...item,
            contentModule: true,
          })
          contentModulePosition += 8
        }
      }
    })
  }

  return newList
}

const getLandingPageCategories = (allCategories) => {
  let materialCat
  const categories = allCategories.filter((category) => {
    const { code } = category
    // Preserve material to rearrange
    if (code === "material") {
      materialCat = category
      return false
    }
    if (code && code !== "price" && code !== "size") {
      return true
    }
    return false
  })

  // Add material at the top irrespective of any data
  if (materialCat) {
    categories.unshift(materialCat)
  }

  return categories
}

/*
 * Function that matching categories from window.DY_SR.data.mensBrandsCategories and API response
 * @prop {object} categores - categories from window.DY_SR.data.mensBrandsCategories
 * @prop {object} categoriesFromAPI - categories from API response
 * */
function getMatchedCategories(categores, categoriesFromAPI) {
  const defaultImage =
    "/david-yurman/assets/images/dummy/SHOT_13_DY_MENSBANDS_MAILER_SL_MODERNLUXURY.jpg"
  const matchedCategories = categoriesFromAPI
    .filter((item) => {
      if (item.name === "Price") {
        return false
      }
      return true
    })
    .map((apiCat) => {
      // set default image and description
      const category = {
        ...apiCat,
        alt: apiCat.name,
        items: apiCat.values.map((val) => {
          return {
            ...val,
            alt: val.name,
          }
        }),
      }

      categores.forEach((cat) => {
        if (convertToSlug(cat.name) === convertToSlug(apiCat.name)) {
          category.code = cat.code

          if (cat.image) {
            category.image = cat.image
          }

          if (cat.description) {
            category.description = cat.description
          }

          if (cat.values && cat.values.length > 0) {
            cat.items = cat.values
          }

          category.items = category.items.map((catVal) => {
            cat.items.forEach((catItem) => {
              if (convertToSlug(catVal.code) === convertToSlug(catItem.code)) {
                if (catItem.image) {
                  catVal.image = catItem.image
                } else {
                  catVal.image = defaultImage
                }

                if (catVal.image === "") {
                  catVal.image = defaultImage
                }

                if (catItem.description) {
                  catVal.description = catItem.description
                } else {
                  catVal.description = `${catItem.name} --default description--`
                }

                if (catItem.recirculation && !catVal.recirculation) {
                  catVal.recirculation = catItem.recirculation
                }
              }
            })
            return catVal
          })
        }
      })

      if (!category.image) {
        category.image = defaultImage
      }

      if (category.image === "") {
        category.image = defaultImage
      }

      if (!category.description) {
        category.description = `${apiCat.name} --default description--`
      }

      if (category.items) {
        category.items = category.items.map((catItem) => {
          if (!catItem.image) {
            catItem.image = defaultImage
          }

          if (catItem.image === "") {
            catItem.image = defaultImage
          }

          if (!catItem.code) {
            catItem.code = convertToSlug(apiCat.name)
          }

          if (!catItem.description) {
            catItem.description = `${catItem.name} --default description--`
          }

          return catItem
        })
      }

      return category
    })

  return matchedCategories
}

const getQueryParams = (queryData) => {
  // const queryParams = {};
  // if (queryData.indexOf('relevance') >= 0) {
  // 	queryParams.basePath = '/content/david-yurman/us/en/products/men/mens-bands';
  // 	queryParams.pageNumber = 0;
  // 	queryParams.pageSize = 1000;
  // 	queryParams.query = queryData;
  // 	queryParams.search = false;
  // 	queryParams.sort = 'relevance';
  // 	queryParams.isMensBands = true;
  // }
  const queryParams = {
    ...queryData,
    //	basePath: '/products/men/mens-bands',
    pageNumber: 0,
    pageSize: 1000,
    //	query: queryData,
    search: false,
    sort: "low_price asc",
    isMensBands: true,
    requestType: "search",
    searchType: "category",
  }
  return queryParams
}

const getRecirculationCategores = (categories, recirculationCat) => {
  let finalCategories
  // Recirculation Categories from AEM
  recirculationCat.map((recirculationItem) => {
    const {
      code: recirculationCode,
      ctaDataText,
      ctaDataLink,
    } = recirculationItem
    finalCategories = categories.map((category) => {
      // let { items } = category;
      if (category.items) {
        category.items = category.items.map((facet) => {
          // Add recirculation to facets as per the logic to display recirculation
          if (convertToSlug(recirculationCode) === convertToSlug(facet.code)) {
            facet.recirculation = recirculationItem
            facet.recirculation.ctaData = {}
            facet.recirculation.ctaData.text = ctaDataText
            facet.recirculation.ctaData.link = ctaDataLink
          }
          return facet
        })
      }
      if (category.name === "All Designs") {
        if (convertToSlug(recirculationCode) === convertToSlug(category.code)) {
          category.recirculation = recirculationItem
          category.recirculation.ctaData = {}
          category.recirculation.ctaData.text = ctaDataText
          category.recirculation.ctaData.link = ctaDataLink
        }
      }
      return category
    })
    return recirculationItem
  })
  return finalCategories
}

/*
When time for integration comes
only thing that should be left in this function
is now commented line (everything else should be deleted).
URL should be checked if there is need for some more paramaters.
queryData is generated in react-app/components/common/pages/MensBandsProductsPage/MensBandsProductsPage.jsx
by function called getQueryData.
*/
function getUrl(queryData) {
  let url = ""

  // if (queryData.indexOf('relevance') >= 0) {
  // 	// Adding the queryData
  // 	url = '/.api.plp.getProductsList.json';
  // }

  // if (
  // 	queryData.indexOf('material') >= 0 &&
  // 	queryData.indexOf('cable-classic') >= 0 &&
  // 	queryData.indexOf('style') === -1
  // ) {
  // 	url = '/.api.mensBands.productsEmpty';
  // } else if (queryData.indexOf('material') >= 0) {
  // 	url = '/.api.mensBands.productsMaterialFilter';
  // } else if (queryData.indexOf('style') >= 0) {
  // 	url = '/.api.mensBands.productsColorFilter';
  // } else if (queryData.indexOf('allCategories') >= 0) {
  // 	url = '/.api.mensBands.productsCollectionFilter';
  // } else if (queryData.indexOf('material') >= 0 && queryData.indexOf('style') >= 0) {
  // 	url = '/.api.mensBands.productsMaterialColorFilter';
  // }

  url = "/.api.plp.getProductsList.json"

  return url
}

function isAuthorInstance() {
  const { Granite = {} } = window
  const layer = Granite.author.layerManager.getCurrentLayer()
    ? Granite.author.layerManager.getCurrentLayer().toLowerCase()
    : ""
  if (layer === "Edit" || layer === "Developer" || layer === "Targeting") {
    return Granite.author.layerManager.getCurrentLayer()
      ? Granite.author.layerManager.getCurrentLayer()
      : false
  }
  return false
}

function isFranceSite() {
  return (
    getValue({ DY_SR: getDY_SR() }, "DY_SR.config.global.baseStore", "") ===
    "fr"
  )
}

function isInternationalCheckoutEnabled() {
  return getValue(
    { DY_SR: getDY_SR() },
    "DY_SR.international.flow.enableInternationalCheckout"
  )
}

function isNaSite() {
  return (
    getValue({ DY_SR: getDY_SR() }, "DY_SR.config.global.baseStore", "") ===
      "dy" ||
    getValue({ DY_SR: getDY_SR() }, "DY_SR.config.global.baseStore", "") ===
      "ca"
  )
}

function iOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  )
}

function isTouch() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}

function getClosestMatch(elem, selector) {
  const polyfilledMatches = (s) => {
    const matches = (this.document || this.ownerDocument).querySelectorAll(s)
    let i = matches.length
    while (--i >= 0 && matches.item(i) !== this) {} // eslint-disable-line no-empty
    return i > -1
  }

  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      polyfilledMatches
  }

  // eslint-disable-next-line no-param-reassign
  for (; elem && elem !== document; elem = elem.parentNode) {
    // Gets the closest matching element:
    if (elem.matches(selector)) return elem
  }
  return null
}

// render registered, copyright, and TM symbols with superscript style
function parseSuperScript(string) {
  return string.replace(/[™®©]/g, `<sup class="mb-superscript">$&</sup>`)
}

function revertFromSlug(Text) {
  return Text.replace(/-/g, " ").replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  )
}

// function isVideoPlaying(video) {
// 	return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
// }

export {
  animateComponents,
  convertToSlug,
  formatPreorderDate,
  filterVariant,
  getCategoryForMensPLP,
  getGridItems,
  getLandingPageCategories,
  getMatchedCategories,
  getQueryParams,
  getRecirculationCategores,
  getUrl,
  handleScrollAnimations,
  isAuthorInstance,
  isInternationalCheckoutEnabled,
  isFranceSite,
  isInViewport,
  isNaSite,
  iOS,
  isTouch,
  getClosestMatch,
  parseSuperScript,
  revertFromSlug,
}
